import moment from "moment";

const formatTime = (time, returnAsFull) => {
  let formattedTime;
  const dateString = moment.utc(time).format("DD/MM/YYYY");
  const timeString = moment.utc(time).format("HH:mm");
  const dateTimeString = moment.utc(time).format("DD/MM/YYYY HH:mm:ss");
  const today = moment().format("DD/MM/YYYY");
  const yesterday = moment().subtract(1, "days").format("DD/MM/YYYY");

  if (dateString === today) {
    formattedTime = timeString;
  } else if (dateString === yesterday) {
    formattedTime = "Yesterday";
  } else {
    formattedTime = dateString;
  }

  if (returnAsFull) {
    return dateTimeString;
  } else {
    return formattedTime;
  }
}

export default formatTime;